const ForsiaPhoneIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14247_54542)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.856 13.1441C9.68602 11.9741 8.80402 10.6641 8.21802 9.33512C8.09402 9.05412 8.16702 8.72512 8.38402 8.50812L9.20302 7.69012C9.87402 7.01912 9.87402 6.07012 9.28802 5.48412L8.11402 4.31012C7.33302 3.52912 6.06702 3.52912 5.28602 4.31012L4.63402 4.96212C3.89302 5.70312 3.58402 6.77212 3.78402 7.83212C4.27802 10.4451 5.79602 13.3061 8.24502 15.7551C10.694 18.2041 13.555 19.7221 16.168 20.2161C17.228 20.4161 18.297 20.1071 19.038 19.3661L19.689 18.7151C20.47 17.9341 20.47 16.6681 19.689 15.8871L18.516 14.7141C17.93 14.1281 16.98 14.1281 16.395 14.7141L15.492 15.6181C15.275 15.8351 14.946 15.9081 14.665 15.7841C13.336 15.1971 12.026 14.3141 10.856 13.1441Z"
          stroke="#C5E86C"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_14247_54542">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ForsiaPhoneIcon;
